import React from 'react';
import { HasCommand, checkScope } from '@folio/stripes/components';
import { AddCommand } from '../../keyboard-shortcuts';
import { handleKeyCommand } from '../../utils';
import { useKeyCommandsMessages } from '../../hooks';
export var HasCommandWrapper = function (_a) {
    var children = _a.children, commands = _a.commands;
    var actionUnavailableError = useKeyCommandsMessages().actionUnavailableError;
    var defaultCommands = [
        AddCommand.duplicate(handleKeyCommand(function () {
            actionUnavailableError();
        })),
        AddCommand.save(handleKeyCommand(function () {
            actionUnavailableError();
        })),
        AddCommand.create(handleKeyCommand(function () {
            actionUnavailableError();
        })),
        AddCommand.edit(handleKeyCommand(function () {
            actionUnavailableError();
        })),
        AddCommand.collapseSections(handleKeyCommand(function () {
            actionUnavailableError();
        })),
        AddCommand.expandSections(handleKeyCommand(function () {
            actionUnavailableError();
        }))
    ];
    var commandsList = defaultCommands.map(function (defaultCommand) {
        var listSpecificCommand = commands.find(function (command) {
            return defaultCommand.name === command.name;
        });
        if (listSpecificCommand) {
            return listSpecificCommand;
        }
        return defaultCommand;
    });
    return (React.createElement(HasCommand, { commands: commandsList, isWithinScope: checkScope, scope: document.body }, children));
};
